import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Train, Users } from "lucide-react";

const CityIntro = ({ city }) => {
  return (
    <section className="py-24 lg:py-32 bg-cream" data-testid="city-intro-section">
      <div className="container-tm grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 lg:order-2">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-lift">
            <img
              src={city.heroImage}
              alt={`${city.name}, Bretagne, port et côte`}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex flex-wrap gap-2">
              <Badge icon={<Train size={14} strokeWidth={2} />} text={city.intro.tgv} />
              <Badge icon={<Users size={14} strokeWidth={2} />} text={`${city.intro.travelers} voyageurs`} />
              <Badge icon={<Calendar size={14} strokeWidth={2} />} text={`~${city.intro.avgPrice} / nuit`} />
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 lg:order-1 lg:pr-8">
          <span className="overline">{city.name} & Airbnb</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            {city.name},
            <span className="italic text-gold"> destination incontournable</span>.
          </h2>
          <p className="mt-7 font-sans text-base md:text-lg text-ink/70 leading-relaxed">
            {city.intro.text}
          </p>

          <div className="mt-10 pt-8 border-t border-ink/10">
            <h3 className="font-serif text-2xl md:text-3xl text-ink leading-tight mb-4">
              Notre service de conciergerie Airbnb à {city.name}
            </h3>
            <p className="font-sans text-base text-ink/70 leading-relaxed">
              {city.intro.serviceText}
            </p>

            {city.slug === "dinard" ? (
              <div
                className="mt-6 bg-sand/60 border border-gold/25 rounded-xl p-5"
                data-testid="dinard-mobilhome-callout"
              >
                <p className="overline text-gold mb-2">Spécialité Dinard</p>
                <p className="font-sans text-sm text-ink/75 leading-relaxed">
                  Vous possédez un mobile home au <strong>Domaine du Bois d'Amour</strong> ou dans un autre parc résidentiel ?
                  {" "}
                  <Link
                    to="/mobil-home-dinard"
                    className="text-gold underline-offset-4 hover:underline font-semibold"
                    data-testid="dinard-mobilhome-link"
                  >
                    Découvrez notre service dédié →
                  </Link>
                </p>
              </div>
            ) : null}

            <Link
              to="/contact"
              state={{ scrollTo: "simulator" }}
              className="btn-accent mt-8 group"
              data-testid="city-intro-cta"
            >
              Calculez vos revenus
              <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

const Badge = ({ icon, text }) => (
  <span className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm text-ink rounded-full px-3 py-1.5 text-[11px] font-sans font-semibold uppercase tracking-[0.18em] shadow-soft">
    <span className="text-gold">{icon}</span>
    {text}
  </span>
);

export default CityIntro;
